"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIDE_PANEL_SCROLLED_CLASS = exports.SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME = exports.SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME = exports.SIDE_PANEL_CLASS = void 0;
var SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME = exports.SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME = 'side-panel-resize-handle';
var SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME = exports.SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME = 'side-panel-resize-handle--dragging';
var SIDE_PANEL_CLASS = exports.SIDE_PANEL_CLASS = 'hb-side-panel';
var SIDE_PANEL_SCROLLED_CLASS = exports.SIDE_PANEL_SCROLLED_CLASS = 'hb-side-panel--scrolled';
//# sourceMappingURL=HBSidePanel.consts.js.map